var setSpecies = require('../internals/set-species');

// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
setSpecies('Array');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.array.species.js
// module id = 292
// module chunks = 0